import { STICKY_HEADER_HEIGHT, TOP_BAR_HEIGHT } from '@va/constants';

const root = document.querySelector('#root') as HTMLElement | null;

export const onTopBarHidden = () => {
  if (!root) return;
  root.style.setProperty('--top-bar-height', '0px');
  root.style.setProperty('--sticky-header-height', `${STICKY_HEADER_HEIGHT - TOP_BAR_HEIGHT}px`);
};

export const onTopBarVisible = () => {
  if (!root) return;
  root.style.setProperty('--top-bar-height', `${TOP_BAR_HEIGHT}px`);
  root.style.setProperty('--sticky-header-height', `${STICKY_HEADER_HEIGHT}px`);
};
